/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnneeFormationSuivieFichierGridDto
 */
export interface AnneeFormationSuivieFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    idanneeFormationSuivieFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AnneeFormationSuivieFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the AnneeFormationSuivieFichierGridDto interface.
 */
export function instanceOfAnneeFormationSuivieFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnneeFormationSuivieFichierGridDtoFromJSON(json: any): AnneeFormationSuivieFichierGridDto {
    return AnneeFormationSuivieFichierGridDtoFromJSONTyped(json, false);
}

export function AnneeFormationSuivieFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnneeFormationSuivieFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idanneeFormationSuivieFichier': !exists(json, 'idanneeFormationSuivieFichier') ? undefined : json['idanneeFormationSuivieFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function AnneeFormationSuivieFichierGridDtoToJSON(value?: AnneeFormationSuivieFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idanneeFormationSuivieFichier': value.idanneeFormationSuivieFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

